const firebaseConfig = {
    apiKey: "AIzaSyCStwrsbTU8sBKUCQ5W-BrhXWpbMyR3Vpo",
    authDomain: "travel-guru-77d29.firebaseapp.com",
    projectId: "travel-guru-77d29",
    storageBucket: "travel-guru-77d29.appspot.com",
    messagingSenderId: "203620000376",
    appId: "1:203620000376:web:9e3f2d3cfc43ff8716c38d"
  };
  export default firebaseConfig;